import * as Task01 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaAbsValueClosedTask";
import { getMaturaTaskTypeCode3 } from "../maturaTaskClassification";
import * as Task02 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaPowerDivisionClosedTask";
import * as Task03 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaRootSumClosedTask";
import * as Task04 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLogPropClosedTask";
import * as Task05 from "../../generators/dzial10_dowody/temat3_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaPowerDivisibilityOpenTask";
import * as Task06 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaDifferenceSquaresClosedTask";
import * as Task07 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLinearInequalityClosedTask";
import * as Task08 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaRationalIntervalOpenTask";
import * as Task09 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaQuadraticInequalityOpenTask";
import * as Task10 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaCubicRootsSumClosedTask";
import * as Task11 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaTextLinearSystemOpenTask";
import * as Task12 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaPiecewiseFunctionOpenTask";
import * as Task13 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaLinearZeroAndValueClosedTask";
import * as Task141 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticFactorClosedTask";
import * as Task142 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticBCSignsClosedTask";
import * as Task143 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticAxisShiftClosedTask";
import * as Task15 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaSequenceNthTermClosedTask";
import * as Task16 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaArithmeticTermClosedTask";
import * as Task17 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaGeometricRatioClosedTask";
import * as Task18 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaArithGeoSignsClosedTask";
import * as Task19 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaTrigTanFromCosClosedTask";
import * as Task20 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaTrigProductSumClosedTask";
import * as Task211 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCentralFromInscribedClosedTask";
import * as Task212 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaArcLengthClosedTask";
import * as Task221 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaTriangleAreaClosedTask";
import * as Task222 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCosineSideClosedTask";
import * as Task23 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaTrapezoidAreasClosedTask";
import * as Task24 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaLinesParamRelationOpenTask";
import * as Task25 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCircleAxesClosedTask";
import * as Task26 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaTriangularPrismVolumeAreaOpenTask";
import * as Task27 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCylinderHeightClosedTask";
import * as Task28 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaParityDigitsH00ClosedTask";
import * as Task29 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaTwoDiceNumberOddDiv3OpenTask";
import * as Task30 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaBarChartStatsOpenTask";
import * as Task31 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaQuadraticRevenueOpenTask";

export const sheet = {
  id: "cke-p-2025-sierpien",
  title: "Matura poprawkowa z matematyki 2025",
  subtitle: "Poziom podstawowy, sierpień 2025",
  sourceLabel: "CKE • Formuła 2023",
  sessionType: "resit",
  taskCount: 31,
  maxPoints: 50,
};

const taskModules = [
  Task01,
  Task02,
  Task03,
  Task04,
  Task05,
  Task06,
  Task07,
  Task08,
  Task09,
  Task10,
  Task11,
  Task12,
  Task13,
  Task141,
  Task142,
  Task143,
  Task15,
  Task16,
  Task17,
  Task18,
  Task19,
  Task20,
  Task211,
  Task212,
  Task221,
  Task222,
  Task23,
  Task24,
  Task25,
  Task26,
  Task27,
  Task28,
  Task29,
  Task30,
  Task31,
];

const moduleByType = Object.create(null);

const pointsByTaskNumber = {
  "1": 1,
  "2": 1,
  "3": 1,
  "4": 1,
  "5": 2,
  "6": 1,
  "7": 1,
  "8": 3,
  "9": 2,
  "10": 1,
  "11": 2,
  "12": 4,
  "13": 1,
  "14.1": 1,
  "14.2": 1,
  "14.3": 1,
  "15": 1,
  "16": 1,
  "17": 1,
  "18": 1,
  "19": 1,
  "20": 1,
  "21.1": 1,
  "21.2": 1,
  "22.1": 1,
  "22.2": 1,
  "23": 1,
  "24": 1,
  "25": 1,
  "26": 4,
  "27": 1,
  "28": 1,
  "29": 2,
  "30": 3,
  "31": 2,
};

function decorateTask(task) {
  const taskNumber = String(task?.source?.taskNumber ?? "");
  const match = /^(\d+)(?:\.(\d+))?$/.exec(taskNumber);
  if (!match) return task;

  const baseNumber = Number(match[1]);
  if (!match[2]) {
    return { ...task, displayBaseNumber: baseNumber };
  }

  return {
    ...task,
    displayBaseNumber: baseNumber,
    maturaGroupId: match[1],
    maturaGroupPart: Number(match[2]),
  };
}

export function generateTasks(variant = "original", generationOptions = {}) {
  return taskModules.map((taskModule) => {
    const original = taskModule.generateTask({ variant: "original" });
    moduleByType[original.type] = taskModule;
    if (variant !== "random") return decorateTask(original);
    // Wariant losowy: generujemy losowa wersje, ale zachowujemy numer zadania
    // z oryginalu, aby uklad i numeracja arkusza pozostaly spojne.
    const randomTask = taskModule.generateTask({ ...generationOptions, variant: "random" });
    randomTask.source = { ...(randomTask.source || {}), taskNumber: original.source?.taskNumber };
    moduleByType[randomTask.type] = taskModule;
    return decorateTask(randomTask);
  });
}

export function generatePagedTasks(variant = "original", generationOptions = {}) {
  return generateTasks(variant, generationOptions).map((task, index) => {
    const taskNumber = String(task.source.taskNumber);
    return {
      index,
      task,
      meta: {
        taskNo: taskNumber,
        code3: getMaturaTaskTypeCode3(task),
        maxPoints: pointsByTaskNumber[taskNumber] || 1,
      },
    };
  });
}

function getModule(task) {
  // Restored exercises may render before this sheet has generated any tasks.
  if (!moduleByType[task?.type]) generateTasks("original");
  const taskModule = moduleByType[task?.type];
  if (!taskModule) {
    throw new Error(`Brak modułu oficjalnego zadania: ${task?.type || "unknown"}`);
  }
  return taskModule;
}

export function renderTask(task) {
  return getModule(task).renderTask(task);
}

export function getInteractionSupport(task) {
  const taskModule = getModule(task);
  return {
    renderInput: typeof taskModule.renderInput === "function",
    checkAnswer: typeof taskModule.checkAnswer === "function",
    renderUserAnswer: typeof taskModule.renderUserAnswer === "function",
  };
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return getModule(task).renderInput?.(task, userAnswer, onChange, disabled) ?? null;
}

export function checkAnswer(task, userAnswer) {
  return getModule(task).checkAnswer?.(task, userAnswer) ?? false;
}

export function renderUserAnswer(userAnswer, task) {
  return getModule(task).renderUserAnswer?.(userAnswer, task) ?? null;
}

export function renderAnswer(task) {
  return getModule(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return getModule(task).renderExplanation(task);
}
